import "core-js/modules/es6.object.freeze.js";
import moment from 'moment/moment';
export var DEFAULT_REPORT_FILTERS = Object.freeze({
  billed_status: null,
  time_frame: 'days_30',
  date_from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
  date_to: moment().format('YYYY-MM-DD'),
  project_ids: [],
  tag_list_ids: [],
  tag_ids: [],
  category_ids: [],
  phase_ids: [],
  client_ids: [],
  group_ids: [],
  member_ids: [],
  rounding_mode: null,
  rounding_minutes: null
});
export var APPROVAL_REQUEST_STATUSES = Object.freeze({
  PENDING_APPROVAL: 'pending_approval',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  UNSUBMITTED: 'unsubmitted'
});
export var APPROVAL_EVENT_TYPES = Object.freeze({
  SUBMISSION: 'submission',
  APPROVAL: 'approval',
  REJECTION: 'rejection',
  WITHDRAWAL: 'withdrawal'
});
export var DEFAULT_EXPENSES_PAGE_FILTERS = Object.freeze({
  time_frame: 'all',
  date_from: null,
  date_to: null,
  description: '',
  client_ids: [],
  project_ids: [],
  group_ids: [],
  member_ids: [],
  expense_category_ids: [],
  billable_status: null
});
export var BUDGET_TYPE = Object.freeze({
  TIME: 'time',
  REVENUE: 'revenue',
  COST: 'cost'
});
export var BUDGET_RECURRENCE = Object.freeze({
  NONE: 0,
  WEEKLY: 1,
  MONTHLY: 2
});
export var BILLING_TYPE = Object.freeze({
  TIME_MATERIAL: 'time_material',
  FIXED_FEE: 'fixed_fee',
  NOT_BILLABLE: 'not_billable'
});
export var DAYS = Object.freeze({
  0: 'sunday',
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday'
});